export default "__VITE_ASSET__BGpnJwFK__"